import { render } from "./Dashboard_history.vue?vue&type=template&id=8dd6f616&scoped=true"
import script from "./Dashboard_history.vue?vue&type=script&lang=js"
export * from "./Dashboard_history.vue?vue&type=script&lang=js"

import "./Dashboard_history.vue?vue&type=style&index=0&id=8dd6f616&scoped=true&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd6f616"]])

export default __exports__